// @ts-nocheck

import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp

export class Categories extends LitElement {
	static properties = {
		categories: { type: Array },
	}

	constructor() {
		super()
		this.categories = []
		this._swiperInitialized = false
	}

	connectedCallback() {
		super.connectedCallback()
		this.getCategories()
	}
	updated(changedProps) {
		if (changedProps.has("categories") && !this._swiperInitialized) {
			this.updateComplete.then(() => {
				const swiperEl = this.querySelector(".category-swiper")
				if (!swiperEl) return
				console.log(swiperEl)
				const params = {
					slidesOffsetAfter: 30,
					breakpoints: {
						320: {
							slidesPerView: 1.2,
							spaceBetween: 10,
						},
						480: {
							slidesPerView: 2.2,
							spaceBetween: 15,
						},
						768: {
							slidesPerView: 3.2,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 4.2,
							spaceBetween: 20,
						},
					},

					injectStyles: [
						`
          :host{
             --swiper-navigation-size: 20px;
            --swiper-navigation-color: #FAFAFA;
          }

          .swiper-button-next, .swiper-button-prev{
            background-color: #4B883C;
            border-radius: 50%;
            width: 38px;
            height: 38px;
          }
          .swiper-button-next svg, .swiper-button-prev svg{
            width: 8.42px;
            height: 14.576px;
          }
        `,
					],
				}

				Object.assign(swiperEl, params)

				swiperEl.initialize()

				this._swiperInitialized = true
			})
		}
	}
	createRenderRoot() {
		return this
	}

	async getCategories() {
		const response = await apiFetch({
			path: `/wc/store/products/categories?hide_empty=false`,
			method: "GET",
		})
		this.categories = response?.filter(cat => {
			return  cat.image !== null
		})
	}

	render() {
		return html`<swiper-container
			slides-per-view=${4}
			navigation
			equal-height
			init="false"
			space-between="20"
			class="category-swiper">
			${this.categories.map(
				category => html`
					<swiper-slide>
						<a href="${category.permalink}" class="category-card">
							${when(
								category.image,
								() => html`<img
									src="${category.image.src}"
									alt="${category.image.alt}"
									class="category-image" />`,
								() => html`<div class="category-image placeholder"></div>`
							)}
							<h3 class="name">${unsafeHTML(category.name)}</h3>
						</a>
					</swiper-slide>
				`
			)}
		</swiper-container>`
	}
}
